/// Constant names for **shared** instances of stores, for example `ingredient-replacement-search.vue` reads
/// from the same instance of recipeSearchStore as `show-recipes-for-ingredient.vue`.
export const RECIPES_CONTAINING_INGREDIENT_SEARCH_STORE = "recipesContainingIngredientSearch";
export const RECIPE_DASHBOARD_SEARCH_STORE = "recipeDashboard.recipeSearch";

// These correspond to constants on `IngredientSearch` module in the backend code.
export const FOOD = "FOOD";
export const NONFOOD = "NONFOOD";

// These correspond to `RecipeDataParams#VALID_DATA_TYPES` in the backend code.
export const NUTRITION_BREAKDOWN = "nutrition_breakdown";
export const LABELS_DATA = "labels";
export const COSTS = "costs";
export const RECIPE = "recipe";
export const INGREDIENT = "ingredient";
export const MENU = "menu_labeling";

export const PDF = "pdf";

export const DATA_TYPES = [
  { value: "data", label: "Recipes" },
  { value: LABELS_DATA, label: "Label Data" },
  { value: "ingredient_lists", label: "Ingredient Lists" },
  { value: "allergens", label: "Allergens" },
  { value: COSTS, label: "Costs" },
  { value: NUTRITION_BREAKDOWN, label: "Nutrition Breakdowns" },
  { value: MENU, label: "Menu Labeling" },
];

export const COST_MODES = [
  { value: RECIPE, label: "All recipe costs" },
  { value: INGREDIENT, label: "All ingredient costs" },
];
